import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { prefetchLoginOrSignupPageDataFromApi, useLoginOrSignupPageDataFromApi } from './pageData';

export type LoginOrSignupPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useLoginOrSignupPageDataFromApi>[0];
}>;

export type CustomLoginOrSignupCombinedState = ReturnType<typeof useLoginOrSignupPageDataFromApi>;

export function usePageContext(prefetchedData?: LoginOrSignupPagePrefetchedContext): CustomLoginOrSignupCombinedState {
	return useLoginOrSignupPageDataFromApi(prefetchedData?.pageData);
}

export async function prefetchPageContext(context: PrefetchContext): Promise<LoginOrSignupPagePrefetchedContext> {
	return { pageData: await prefetchLoginOrSignupPageDataFromApi(context) };
}

export type LoginOrSignupPrefetchedDataProps = PrefetchedDataProps<LoginOrSignupPagePrefetchedContext>;
